export default __webpack_public_path__ + "755a8d0db5969a5ca273d8aedaedd01b.png";